import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getMotivosEstudiante } from "../../services/apis_estudiante";
import { crearMeson } from "../../services/apis_jefatura";

function CrearModuloModal({ show, onClose, onCreate, onModulosChanged }) {
    const [motivosPosibles, setMotivos] = useState([]);
    const [motivosSeleccionados, setMotivosSeleccionados] = useState([]);
    const [nombreModulo, setNombreModulo] = useState("");
    const [numeroModulo, setNumeroModulo] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getMotivosEstudiante();
                setMotivos(data);
            } catch (err) {
                console.error("No se pudieron cargar los motivos", err);
            }
        };
        fetchData();
    }, []);

    const seleccionarMotivo = (motivo) => {
        const isSelected = motivosSeleccionados.some((m) => m.id === motivo.id);
        if (isSelected) {
            // Quitar del array si ya está seleccionado
            setMotivosSeleccionados((prev) =>
                prev.filter((m) => m.id !== motivo.id)
            );
        } else {
            // Agregar al array
            setMotivosSeleccionados((prev) => [...prev, motivo]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Validaciones
            // Seleccionar motivos es opcional; se pueden agregar luego desde edición
            if (!numeroModulo || numeroModulo < 1 || numeroModulo > 10) {
                alert("El número de módulo debe estar entre 1 y 10.");
                return;
            }

            // Creamos el objeto para la API
            const nuevoMeson = {
                nombre: nombreModulo,
                numero: parseInt(numeroModulo),
                estado: "inactivo",
                motivos: motivosSeleccionados.map((motivo) => motivo.id)
            };
        
            const respuesta = await crearMeson(nuevoMeson);
            console.log("Mesón creado:", respuesta);
        
            // Callback al componente padre para actualizar la lista
            onCreate(respuesta);
        
            // Reset del formulario
            setNombreModulo("");
            setNumeroModulo("");
            setMotivosSeleccionados([]);
            onClose();
            onModulosChanged?.();
            } catch (err) {
            console.error("Error creando mesón:", err);
            }
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Crear Módulo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {/* Nombre */}
                    <Form.Group className="mb-3" controlId="formNombreModulo">
                        <Form.Label>Nombre del Módulo</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ingrese nombre"
                            required
                            value={nombreModulo}
                            onChange={(e) => setNombreModulo(e.target.value)}
                        />
                    </Form.Group>

                    {/* Número */}
                    <Form.Group className="mb-3" controlId="formNumeroModulo">
                        <Form.Label>Número del Módulo</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Ingrese número"
                            required
                            min={1}
                            max={10}
                            value={numeroModulo}
                            onChange={(e) => setNumeroModulo(e.target.value)}
                        />
                    </Form.Group>

                    {/* Estado (solo informativo) */}
                    <Form.Group className="mb-3" controlId="formEstadoModulo">
                        <Form.Label>Estado</Form.Label>
                        <Form.Control
                            type="text"
                            value="Inactivo"
                            disabled
                            readOnly
                        />
                    </Form.Group>

                    {/* Motivos (múltiples) */}
                    <Form.Group className="mb-3" controlId="formMotivos">
                        <Form.Label>Motivo de Atención (opcional)</Form.Label>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                            {motivosPosibles.map((motivo) => {
                                const isSelected = motivosSeleccionados.some(
                                    (m) => m.id === motivo.id
                                );
                                return (
                                    <span
                                        key={motivo.id ?? motivo.nombre}
                                        className="badge"
                                        onClick={() => seleccionarMotivo(motivo)}
                                        style={{
                                            cursor: "pointer",
                                            backgroundColor: isSelected ? "black" : "white",
                                            color: isSelected ? "white" : "black",
                                            border: "1px solid black",
                                            borderRadius: "20px",
                                            padding: "8px 14px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                        }}
                                    >
                                        {isSelected && <i className="bi bi-check-lg"></i>}
                                        {motivo.nombre}
                                    </span>
                                );
                            })}
                            {motivosPosibles.length === 0 && (
                                <span style={{ color: "#666" }}>No hay motivos disponibles</span>
                            )}
                        </div>
                    </Form.Group>

                    <Button variant="secondary" onClick={onClose} className="me-2">
                        Cancelar
                    </Button>
                    <Button type="submit" className="btn-accent">
                        Crear
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default CrearModuloModal;